<template>
  <div class="jisao1">
    <div class="contentdiv">
      <div class="con">
        <!-- <p class="title">请选择要祭扫的墓</p> -->
        <van-cell-group>
          <van-field v-model="form.replaceTombName" label="墓主" input-align="right" />
        </van-cell-group>
      </div>
      <div class="line"></div>
      <div class="con">
        <!-- <p class="title">请选择要祭扫的墓</p> -->
        <van-cell-group>
          <van-field v-model="form.replaceAddress" label="墓位" input-align="right" />
        </van-cell-group>
      </div>
      <div class="line"></div>
      <div class="con">
        <!-- <p class="title">请选择祭扫时间</p> -->
        <van-cell title="祭扫日期" :value="form.replacePreDate" @click="showDate = true" />
        <van-calendar v-model="showDate" @confirm="onReplacePreDate" />
        <div></div>
      </div>
      <div class="line"></div>
      <div class="con">
        <p class="title">请选择服务项目</p>
          <ul class="con-list clearfix" v-for="(item) in goodsList" :key="item.id">
            <li>
              <div
                :class="goodsSelectIds.indexOf(item.id) > -1 ? 'label active' : 'label'"
                @click="clickActvie(item.id)"
              ></div>
              <div class="img" :style="getFirstPhotoStyle(item.firstPhoto)"></div>
              <div class="text">
                <p class="name">{{ item.proName }}</p>
                <p class="price">￥{{ item.price }}</p>
                <!---->
              </div>
              <div class="btn" @click="goGoodsInfo(item.id)"><p>查看介绍</p></div>
            </li>
          </ul>
      </div>
      <div class="line"></div>
      <div class="con">
        <p class="title">备注</p>
        <textarea rows="4"  v-model="form.replaceMemo" placeholder="备注(请填写推荐人姓名)" class="textarea"></textarea>
      </div>
      <!---->
    </div>
    <div class="clear-both"></div>
    <div class="foot">
      <div class="info">
        合计 :
        <span class="price">￥{{ priceTotal }}</span>
      </div>
      <a
        v-if="
          form.replaceTombName &&
            form.replaceAddress &&
            form.replacePreDate &&
            goodsSelectIds.length > 0
        "
        href="javascript:void(0)"
        @click="submitPay()"
      >
        <div class="btn">提交预订</div>
      </a>
      <a v-else href="javascript:void(0)" style="background:#ccc;" @click="checkForm()">
        <div class="btn">提交预订</div>
      </a>
    </div>
    <van-action-sheet v-model="show" title="标题">
      <div class="content">
        <div>
          <div class="opendiv">
            <div class="header">
              <div class="img">
                <img src="../../assets/shop.jpg" style="width:100%;" />
              </div>
              <div class="text">
                <p class="name">{{goodsInfo['proName']}}</p>
                <p class="price">￥{{goodsInfo['price']}}</p>
              </div>
            </div>
            <div class="condiv1 condiv1Pop">
              <ul class="info-list">
                <li><span style="color: rgb(50, 50, 50);">图片介绍</span></li>
                <li>
                  <div class="img" v-for="(item2,index2) in goodsInfo['gallery']" :key="index2">
                    <img :src="item2" style="width:100%;" />
                  </div>
                </li>
                <!---->
                <li>
                  <span style="color: rgb(50, 50, 50);">详细介绍</span>
                </li>
                <li style="color: rgb(153, 153, 153);" v-html="goodsInfo['proDetail']"></li>
                <!---->
              </ul>
            </div>
          </div>
          <div class="clear-both"></div>
          <div class="foot">
            <div class="btn" style="width: 100%;" @click="show = false">关闭</div>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  name: 'jisao1',
  data() {
    return {
      priceTotal: 0,
      show: false,
      showDate: false,
      active: 'flower',
      goodsSelectIds: [],
      goodsList: [],
      goodsTotal: 0,
      categories: [],
      goodsInfo: {
        gallery:[],
      },
      form: {
        myId: this.$store.getters.userId,
        replaceTombId: 0,
        replaceTombName: '',
        replacePreDate: '',
        replaceAddress: '',
        replaceMemo: '',
        goodsIds: [],
      },
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path.indexOf('/jisao/detail') > -1) {
      localStorage.setItem('reload', 'true')
    } else {
      localStorage.removeItem('reload')
    }
    next()
  },
  created() {
    if (localStorage.getItem('reload')) {
      location.reload()
    }
    var params = this.$route.params
    var id = params['id']
    if (id) {
      this.queryTombOne(id)
    }
    this.queryGoodsPage()
  },
  methods: {
    checkForm() {
      //form.replaceTombName && form.replaceAddress && form.replacePreDate && goodsSelectIds.length > 0
      if (!this.form.replaceTombName) {
        this.$notify({
          message: '墓主不能为空~',
          color: '#ad0000',
          background: '#ffe1e1',
        })
      } else if (!this.form.replaceAddress) {
        this.$notify({
          message: '墓位信息不能为空~',
          color: '#ad0000',
          background: '#ffe1e1',
        })
      } else if (!this.form.replacePreDate) {
        this.$notify({
          message: '祭扫日期不能为空~',
          color: '#ad0000',
          background: '#ffe1e1',
        })
      } else if (this.goodsSelectIds.length == 0) {
        this.$notify({
          message: '请选择服务项目~',
          color: '#ad0000',
          background: '#ffe1e1',
        })
      }
    },
    submitPay() {
      var that = this
      this.form.goodsIds = this.goodsSelectIds
      this.$submit('/api/order/addOrderWithReplace', this.form, function(res) {
        if (res['code'] === 1) {
          that.$router.push({ path: '/shop/payok', query: { orderNo: res['data']['orderNo'] } })
        }
      })
    },
    // goType() {
    //   this.goodsList = []
    //   this.goodsTotal = 0
    //   this.queryGoodsPage(this.active)
    // },
    getClass() {
      return 'label active'
    },
    clickActvie(goodsId) {
      let _index = this.goodsSelectIds.indexOf(goodsId)
      if (_index > -1) {
        this.goodsSelectIds.splice(_index, 1)
      } else {
        this.goodsSelectIds.push(goodsId)
      }
    },
    queryTombOne(id) {
      var that = this
      this.$queryOne(
        'MemTomb',
        { id: id },
        ['id', 'firstName', 'areaName', 'areaRow', 'areaCol'],
        function(res) {
          if (res['code']) {
            that.form.replaceTombName = res['data']['firstName']
            that.form.replaceAddress = `${res.data.areaName} ${res.data.areaRow}排${res.data.areaCol}号`
          }
        }
      )
    },
    // queryCategory(){
    //   var that = this
    //   this.category = []
    //   var goodsCategory = this.$store.getters.codelist['GOODS_REPLACE_TYPE']
    //   Object.keys(goodsCategory).forEach(function (key) {
    //       that.categories.push({value:key, label: goodsCategory[key]})
    //       that.$set(that.goodsMap, key, [])
    //       that.queryGoodsPage(key)
    //   });
    // },
    queryGoodsPage() {
      var that = this
      this.$queryAll(
        'ProGoods',
        { channel: 'replace',sort:{orderNum:1}},
        ['id,proName,price,firstPhoto,gallery,proDetail'],
        function(res) {
          that.$fill(that.goodsList, res['data'])
        }
      )
    },
    goGoodsInfo(id){
      for(var i=0;i<this.goodsList.length;i++){
        if(this.goodsList[i]['id']==id){
          this.goodsInfo = this.goodsList[i];
          break
        }
      }
      this.show = true
    },
    getFirstPhotoStyle(firstPhoto) {
      return 'background-image: url("' + firstPhoto + '")'
    },
    onReplacePreDate(predate) {
      this.showDate = false
      this.form.replacePreDate = this.formatDate(predate)
    },
    formatDate(predate) {
      return `${predate.getFullYear()}-${predate.getMonth() + 1}-${predate.getDate()}`
    },
  },
  watch: {
    goodsSelectIds() {
      let _priceTotal = 0
      this.goodsList.map(item => {
        if (this.goodsSelectIds.indexOf(item.id) > -1) {
          _priceTotal = _priceTotal + parseInt(item.price)
        }
      })
      this.priceTotal = _priceTotal
    },
  },
}
</script>

<style>
.jisao1 .contentdiv {
  padding: 1rem;
  font-size: 1.6rem;
}
.jisao1 .con {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.jisao1 .con .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}

.jisao1 .line {
  width: 100%;
  height: 1rem;
}
.jisao1 .con .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}
.jisao1 .con .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}
.jisao1 .clearfix:after,
.jisao1 .clearfix:before {
  content: ' ';
  display: table;
}
.jisao1 .clearfix:after {
  clear: both;
}
.jisao1 .clearfix:after,
.jisao1 .clearfix:before {
  content: ' ';
  display: table;
}
.jisao1 .con ul.con-list li {
  min-height: 10rem;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: 1.4rem;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  align-items: center;
}
.jisao1 .con ul.con-list li .label {
  width: 1.8rem;
  height: 8rem;
  background-image: url(../../assets/no.png);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
}
.jisao1 .con ul.con-list li .img {
  width: 8rem;
  height: 8rem;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
.jisao1 .con ul.con-list li .text {
  width: 13rem;
}
.jisao1 .con ul.con-list li .text .name {
  font-size: 1.6rem;
  color: #323232;
  line-height: 2.2rem;
}
.jisao1 .con .name {
  font-size: 1.4rem;
  color: #999;
}
.jisao1 .con ul.con-list li .text .price {
  margin-top: 0.4rem;
  font-size: 1.4rem;
  color: #15a892;
  line-height: 2rem;
}
.jisao1 .con .price {
  font-size: 1.3rem;
  color: #15a892;
}
.jisao1 .con ul.con-list li .btn > p {
  width: 7rem;
  height: 3rem;
  line-height: 3rem;
  background: #15a892;
  font-size: 13px;
  font-weight: 400;
  color: #fff;
  text-align: center;
}
.jisao1 .con .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}
.jisao1 .con .textarea {
  width: 100%;
  font-size: 1.4rem;
  border: 1px solid #eee;
  padding: 0.5rem;
  margin-bottom: 1rem;
  display: inline-block;
  line-height: 2rem;
  height: 9rem;
  box-sizing: border-box;
}
input,
input[type='button'],
input[type='reset'],
input[type='search'],
input[type='submit'],
textarea {
  -webkit-appearance: none;
}

.jisao1 .clear-both {
  clear: both;
  height: 5rem;
}
.jisao1 .foot {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  font-size: 1.6rem;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
}
.jisao1 .foot .info {
  padding-right: 1.7rem;
}
.jisao1 .foot .info .price {
  color: #15a892;
  font-weight: bolder;
}
.jisao1 .foot .btn {
  width: 13.5rem;
  font-size: 1.4rem;
  text-align: center;
  background-color: #15a892;
  color: #fff;
}
.jisao1 .con ul.con-list li .label.active {
  background-image: url(../../assets/yes.png);
}
.jisao1 .opendiv {
  width: 100%;
  height: 100%;
  position: relative;
}
.jisao1 .opendiv .cancel {
  width: 5rem;
  height: 5rem;
  padding: 1.8rem 1.8rem 0 0;
  font-size: 2.6rem;
  position: absolute;
  top: 0;
  right: 0;
  color: #999;
  line-height: 1.1rem;
  text-align: right;
}
.jisao1 .opendiv .header {
  min-height: 10rem;
  padding: 1.8rem;
  box-sizing: border-box;
  font-size: 1.4rem;
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid #eee;
  align-items: center;
}

.jisao1 .opendiv .header .img {
  width: 8rem;
  height: 8rem;
  margin-right: 1.5rem;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
.jisao1 .opendiv .header .text {
  width: 13rem;
  margin-right: 1rem;
}
.jisao1 .opendiv .header .text .name {
  font-size: 1.6rem;
  color: #323232;
  line-height: 2.2rem;
}

.jisao1 .opendiv .header .text .price {
  margin-top: 1.6rem;
  font-size: 1.4rem;
  color: #15a892;
  line-height: 2rem;
}
.jisao1 .condiv1Pop {
  width: 100%;
  height: 28rem;
  overflow-x: hidden;
  overflow-y: auto;
}

.jisao1 .condiv1 {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.jisao1 .condiv1 ul.info-list {
  padding-top: 1.5rem;
}
.jisao1 .condiv1 ul.info-list > li {
  width: 100%;
  color: #323232;
  font-size: 1.4rem;
  line-height: 2rem;
  padding-bottom: 1.5rem;
  display: flex;
  justify-content: flex-start;
}
.jisao1 .condiv1 ul.info-list > li span {
  color: #999;
  width: 7.5rem;
  display: block;
  flex: none;
}
.jisao1 .condiv1 ul.img-list {
  width: 100%;
  margin-left: -0.5rem;
}
.jisao1 .opendiv .condiv1 ul .img-list > li {
  margin: 0 0.5rem 0.5rem;
}

.jisao1 .condiv1 ul.img-list > li {
  width: calc(20% - 1rem);
  overflow: hidden;
  float: left;
  line-height: normal;
  margin: 0 0.5rem 1.5rem;
}
.jisao1 .condiv1 ul.img-list > li .img,
.jisao1 .condiv1 ul.img-list > li img {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
